module.exports = __webpack_public_path__ + "static/PhilDavis-b714925bf81b3fa28f105b9c7ef468c8.jpg";